/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownStatus/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import DropdownOptionsStatus from 'DesignSystem/DropdownOptionsStatus/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DropdownStatus({
  children,
  viewPath = "/DesignSystem/DropdownStatus",
  marginLeft,
  dropdownRef,
  isDisabled,
  onClick,
  value,
  toggleIsShowing,
  isShowing,
  field = "text",
  from,
  selected,
  width
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DropdownStatus.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1NVSU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DropdownStatus.Horizontal"
  data-view-path={viewPath}
 ref={dropdownRef}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 disabled={isDisabled}
 size="normal"
 type="primary"
 onClick={onClick}
 marginRight={2}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={value}
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 disabled={isDisabled}
 onClick={toggleIsShowing}
 size="normal"
 type="ghost"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<div
  data-testid="DropdownStatus.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={12}
 height={12}
 stroke="#323232"
 fill="transparent"
/>
</div>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<fromFlow.When is={isShowing}>
<DropdownOptionsStatus
  viewPath={`${viewPath}/DropdownOptionsStatus`}
 field={field}
 from={from}
 onClick={onClick}
 selected={selected}
 height={166}
 width={width}
 bottom={42}
 alignSelf="flex-end"
 textAlign="right"
/>
</fromFlow.When>
</div>
</div>
{children}
</React.Fragment>)
}